export const SLARadioAttributes = [
    {value: "true", text: "사용함"},
    {value: "false", text: "사용안함"},
];

export const RadioAttributes = [
    {value: "disable", text: "사용안함", id: "disable"},
    {value: "enable", text: "사용함", id: "enable"},
];

export const SmtpAttributes = [
    {value: "false", text: "사용안함", id: "false"},
    {value: "true", text: "사용함", id: "true"},
]

export const InspectionReportOutput = [
    {value: "false", text: "점검별", id: "false"},
    {value: "true", text: "자산별", id: "true"},
]

export const ListManagementControl = [
    {value: "true", text: "시스템 계정", id: "true"},
    {value: "false", text: "사용자별", id: "false"},
]

export const ApprovalRadioAttributes = [
    {value: "APPROVED", text: "결재", className: "text-[13px]"},
    {value: "REJECTED", text: "반려", className: "text-[red] text-[13px]"},
];

export const ExamineRadioAttributes = [
    {value: "ADJUST", text: "마감일 조정"},
    {value: "TRANSFER", text: "이관"},
    {value: "REJECT", text: "반려", className: "text-[red]"},
]

export const AiManagementControl = [
    {value: "true", text: "관리자", id: "true"},
    {value: "false", text: "사용자", id: "false"},
]

export const DepartmentRadioOutput = [
    {value: "false", text: "사용안함", id: "false"},
    {value: "true", text: "사용함", id: "true"},
]